import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from '../../api/endpoints.js';
import Page from "../Page.js";
import EditFormPartial from "./EditFormPartial.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ServiceCenter from '../../models/ServiceCenter';
import { toast } from 'react-toastify';

const Edit = () => {
  const [serviceCenter, setServiceCenter] = useState((new ServiceCenter()).toStateJson());
  let serviceCenterObj = new ServiceCenter(serviceCenter);
  const [fetchApi] = getApi('showServiceCenter');
  const [updateApi] = getApi('updateServiceCenter');
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id.replace(/\D/g, "") }).unwrap();
      setServiceCenter((new ServiceCenter(response.data.service_center, 1)).toStateJson());
    } catch(error) {
      toast.error("Something Went Wrong !")
    }
  }

  const updateRecord = async (params) => {
    try {
      let response = await updateApi(params).unwrap();
      if(response.data?.errors !== null){
        serviceCenterObj.set_api_errors(response.data.errors);
        if(Object.keys(response.data?.errors).length === 0){
          navigate("/service_centers");
          toast.success("Updated Successfully");
        } else {
          toast.warning("Partially updated. Please correct errors to complete update.")
        }
      } else {
        navigate("/service_centers");
        toast.success("Updated Successfully");
      }
    } catch(error) {
      serviceCenterObj.set_api_errors(error.data.data.errors);
      toast.error(JSON.stringify(error.data.data.errors) || "Something went wrong !");
    }
  }

  const onUpdateClick = () => {
    try{
      updateRecord((new ServiceCenter(serviceCenter)).toEditApiJson());
    } catch(error){
      setServiceCenter(new ServiceCenter(serviceCenter));
    }
  }

  const onBackClick = () => {
    navigate("/service_centers");
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditServiceCenterPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Service Centers", url: '/service_centers' }, { label: "Edit" }]}
    className={'service-center-edit-page'}
  >
    <PageContentWrapper contentHeading={`Edit Service Center (${serviceCenterObj?.id})`}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <EditFormPartial serviceCenter={serviceCenter} setServiceCenter={setServiceCenter}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>
                Back
              </button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>
                Update Service Center
              </button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Edit;
